// extracted by mini-css-extract-plugin
module.exports = {"control":"AddManually_control__23tBa","valueContainer":"AddManually_valueContainer__1VRzq"};